// @/composables/useAppInfo.ts
import { computed } from 'vue'

export function useAppInfo() {
  const version = import.meta.env.VITE_APP_VERSION || 'dev'
  const buildDate = import.meta.env.VITE_BUILD_DATE || new Date().toISOString()
  const commitHash = import.meta.env.VITE_COMMIT_HASH || 'unknown'
  const environment = import.meta.env.MODE || 'development'
  const isDev = import.meta.env.DEV
  const isProd = import.meta.env.PROD

  const currentYear = new Date().getFullYear()

  const formattedVersion = computed(() => {
    if (version.length === 7 && !version.startsWith('v')) {
      return `v${version}`
    }
    return version.startsWith('v') ? version : `v${version}`
  })

  const formattedBuildDate = computed(() => {
    try {
      const date = new Date(buildDate)
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    } catch {
      return 'Data inválida'
    }
  })

  const shortBuildDate = computed(() => {
    try {
      const date = new Date(buildDate)
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    } catch {
      return 'Data inválida'
    }
  })

  const formattedCommitHash = computed(() => {
    return commitHash.substring(0, 7) // Garante 7 caracteres
  })

  const fullVersionInfo = computed(() => {
    if (isDev) {
      return `${formattedVersion.value} (dev)`
    }
    return `${formattedVersion.value} (${formattedCommitHash.value})`
  })

  const versionDisplay = computed(() => {
    return `Versão ${formattedVersion.value}`
  })

  const detailedInfo = computed(() => ({
    version: formattedVersion.value,
    commitHash: formattedCommitHash.value,
    buildDate: formattedBuildDate.value,
    environment,
    isDev,
    isProd,
  }))

  const logVersionInfo = () => {
    // Informações de versão disponíveis em dev
  }

  return {
    version,
    buildDate,
    commitHash,
    environment,
    isDev,
    isProd,
    currentYear,

    formattedVersion,
    formattedBuildDate,
    shortBuildDate,
    formattedCommitHash,
    fullVersionInfo,
    versionDisplay,
    detailedInfo,

    logVersionInfo,
  }
}
